import { render, staticRenderFns } from "./editWay.vue?vue&type=template&id=355d9f44&scoped=true&"
import script from "./editWay.vue?vue&type=script&lang=js&"
export * from "./editWay.vue?vue&type=script&lang=js&"
import style0 from "./editWay.vue?vue&type=style&index=0&id=355d9f44&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355d9f44",
  null
  
)

export default component.exports